// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-Dvf4Y";
var _3 = "service_active-3oi2d";
var _4 = "header-3F9Md";
var _5 = "loyalty-_9Ynm";
var _6 = "icon-3lBFR";
export { _1 as "__esModule", _2 as "content", _3 as "service_active", _4 as "header", _5 as "loyalty", _6 as "icon" }
export default { "__esModule": _1, "content": _2, "service_active": _3, "header": _4, "loyalty": _5, "icon": _6 }
